export interface FileDownloadData {
  url: string;
  filename: string;
}
export const handleFileDownload = ({url, filename}: FileDownloadData) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
